<script setup lang="ts">
  import {
    NotificationHeader,
    NotificationTable,
    NotificationQuantitySelect,
    NotificationListNavigation,
  } from '../ui';
  import { useNotificationList } from '../model';

  const HEADERS = [
    'Notificações',
    'Criado por',
    'Destinatários',
    'Data de Início',
    'Data Final',
    'Periodicidade',
    'Status',
    'Ações',
  ];

  const {
    notifications,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    searchTerm,
    searchType,
    isFilterActive,
    orderOptions,
    headers,
    canCreateNotification,
    loading,
    loadingMore,
    hasMoreNotifications,
    isExportButtonDisabled,
    onPageChanged,
    handleQuantityChange,
    handleSearch,
    handleNotificationDeleted,
    handleFilterUpdate,
    handleFilterClicked,
    handleSelectedNotificationsUpdate,
    handleExportToExcel,
    handleSearchTypeChange,
    handleSortOptions,
  } = useNotificationList({
    headers: HEADERS,
    canCreateNotification: false,
  });
</script>

<template>
  <section>
    <div>
      <NotificationHeader
        :disabled="isExportButtonDisabled"
        :can-create-notification="canCreateNotification"
        :initial-search-term="searchTerm"
        :initial-search-type="searchType"
        @search="handleSearch"
        @search-type-change="handleSearchTypeChange"
        @export-to-excel="handleExportToExcel"
      >
        <template
          v-if="notifications.length > 0"
          #quantity
        >
          <NotificationQuantitySelect
            v-model="itemsPerPage"
            @change="handleQuantityChange"
          />
        </template>
      </NotificationHeader>
      <NotificationTable
        :order-options="orderOptions"
        :notifications="notifications"
        :current-page="currentPage"
        :total-pages="totalPages"
        :total-records="totalItems"
        :is-filter-active="isFilterActive"
        :search-term="searchTerm"
        :loading="loading"
        :headers="headers"
        @update:sort="handleSortOptions"
        @notification-deleted="handleNotificationDeleted"
        @update:filter="handleFilterUpdate"
        @filter-clicked="handleFilterClicked"
        @update:selected-notifications="handleSelectedNotificationsUpdate"
      />
      <NotificationListNavigation
        :notifications="notifications"
        :items-per-page="itemsPerPage"
        :total-items="totalItems"
        :current-page="currentPage"
        :loading-more="loadingMore"
        :has-more-items="hasMoreNotifications"
        @page-changed="onPageChanged"
      />
    </div>
  </section>
</template>
